import { useState } from 'react';
import { Layout, TableCell, TableLayout } from 'components/Hospital/PaginationForms';
import { clPatientInfoTableHeader, clPatientInfoTableWidth } from 'constants/pagination';
import CLPatientInfoTableBody from './CLPatientInfoTableBody';
import { ICLDailyStatistics } from 'models/CL/CLBasicInterface';
import styled from 'styled-components';
import { Radius } from 'styles/Global/objectStyles';
import { BackgroundColor, BorderColor } from 'styles/Global/colorSemantic';
import InfoCircle from 'assets/Icons/Info/InfoCircle';
import ClSuccessToolTip from 'components/ToolTip/ClSuccessToolTip';
import ClTooltipQuestionIcon from 'assets/Icons/ToolTip/ClTooltipQuestionIcon';

interface CLPatientInfoTableProps {
    currentData?: ICLDailyStatistics[];
}

const CLPatientInfoTable = ({ currentData }: CLPatientInfoTableProps) => {
    const [selectHeader, setSelectHeader] = useState<string>('');
    const [showTooltip, setShowTooltip] = useState<boolean>(false);
    
    return (
        <Layout>
            <TableLayout>
                <HeaderWrapper $count={currentData?.length || 0}>
                    {clPatientInfoTableHeader.map((name, idx) => {
                        return (
                            <TableCell
                                key={idx}
                                $idx={idx}
                                $width={clPatientInfoTableWidth[idx]}
                                $type='header'
                                $justifyContent='space-between'
                                hover={setSelectHeader}
                                cellType={name.type !== 'null' && name.type !== 'patientMobile' ? name.type : undefined}
                                $height='48px'
                                $show='always'
                            >
                                <HeaderContentWrapper>
                                    {name.title}
                                    {name.type === 'success' && (
                                        <InfoIconContainer
                                            onMouseEnter={() => setShowTooltip(true)}
                                            onMouseLeave={() => setShowTooltip(false)}
                                        >
                                            <ClTooltipQuestionIcon />
                                            {showTooltip && <ClSuccessToolTip />}
                                        </InfoIconContainer>
                                    )}
                                </HeaderContentWrapper>
                                {/* {name.type === 'date' && (sortField === name.type || selectHeader === 'date') && sortDirections && handleSorting && (
                                    <LabelSelectButton onClick={() => handleSorting(name.type)}>{sortDirections[name.type] ? '최신순' : '오래된순'}</LabelSelectButton>
                                )} */}
                            </TableCell>
                        );
                    })}
                </HeaderWrapper>
                {/* {currentData?.length === 0 ? <NothingDataInPagination initNumber={initNumber} handleResetButton={handleResetButton} /> : <CLPatientInfoTableBody currentData={currentData} />} */}
                <CLPatientInfoTableBody currentData={currentData} />
            </TableLayout>
        </Layout>
    );
};

export default CLPatientInfoTable;

const HeaderWrapper = styled.div<{ $count: number }>`
    display: flex;
    width: 100%;
    height: 48px;
    border-radius: ${Radius.radius_4} ${Radius.radius_4} 0 0;
    background-color: ${BackgroundColor.color_background_neutral};
    border-bottom: 1px solid ${BorderColor.color_border_neutral};
    box-shadow: ${(props) => (props.$count > 12 ? `0 2px 8px -2px rgba(0, 0, 0, 0.2)` : 'none')};
`;

const HeaderContentWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
`;

const InfoIconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    opacity: 0.7;
    transition: opacity 0.2s ease;
    
    &:hover {
        opacity: 1;
    }
`;
